/**
 * 路由名称常量
 */
export const ROUTE_NAMES = {
    PROOF_READING: 'proof-reading',
    SPECIFICATION: 'specification',
    OAR: 'oar',
    PATENT_DRAFTING_V1: 'patent-drafting-v1',
} as const;
